// extracted by mini-css-extract-plugin
export default {"wrapper":"OffsetActions_wrapper__QI7x3","input":"OffsetActions_input__f6PUb","input__label":"OffsetActions_input__label__aMYOG","actions":"OffsetActions_actions__6tmVD"};